import React from "react";
import style from "./faq.module.css"

const Faq=()=>{
    return(
        <div className={style.section}>
            <div className={style.wrap}>
                <h2 className={style.heading}>FAQs</h2>
                <div className={style.container} >
                    <div className={style.gridrow}>
                        <section className={style.gridrowcol} >
                            <div className={style.cont}>
                              <h3 className={style.accodiantext}>What is online doctor consultation?</h3>
                              <p className={style.accodiantextsub}>
                                  <span>Online doctor consultation or online medical consultation is a method .... </span>
                                    <a className={style.link1} href="/video-consult">Read More</a>
                              </p>
                            </div>
                        </section>
                        <section className={style.gridrowcol} >
                            <div className={style.cont}>
                              <h3 className={style.accodiantext}>What is online doctor consultation?</h3>
                              <p className={style.accodiantextsub}>
                                  <span>Online doctor consultation or online medical consultation is a method .... </span>
                                    <a className={style.link1} href="/video-consult">Read More</a>
                              </p>
                            </div>
                        </section>
                        <section className={style.gridrowcol} >
                            <div className={style.cont}>
                              <h3 className={style.accodiantext}>What is online doctor consultation?</h3>
                              <p className={style.accodiantextsub}>
                                  <span>Online doctor consultation or online medical consultation is a method .... </span>
                                    <a className={style.link1} href="/video-consult">Read More</a>
                              </p>
                            </div>
                        </section>
                        <section className={style.gridrowcol} >
                            <div className={style.cont}>
                              <h3 className={style.accodiantext}>What is online doctor consultation?</h3>
                              <p className={style.accodiantextsub}>
                                  <span>Online doctor consultation or online medical consultation is a method .... </span>
                                    <a className={style.link1} href="/video-consult">Read More</a>
                              </p>
                            </div>
                        </section>
                        <section className={style.gridrowcol} >
                            <div className={style.cont}>
                              <h3 className={style.accodiantext}>What is online doctor consultation?</h3>
                              <p className={style.accodiantextsub}>
                                  <span>Online doctor consultation or online medical consultation is a method .... </span>
                                    <a className={style.link1} href="/video-consult">Read More</a>
                              </p>
                            </div>
                        </section>
                        <section className={style.gridrowcol} >
                            <div className={style.cont}>
                              <h3 className={style.accodiantext}>What is online doctor consultation?</h3>
                              <p className={style.accodiantextsub}>
                                  <span>Online doctor consultation or online medical consultation is a method .... </span>
                                    <a className={style.link1} href="/video-consult">Read More</a>
                              </p>
                            </div>
                        </section>
                      
                    </div>

                </div>

            </div>

        </div>
    )
}

export default Faq